<template>
  <div class="container info-container">
    <h1>FAQ</h1>
    <ul class="list-none">
      <li>
        <p><span class="step">Can I choose the exact place on the Pixel Wall?</span>
        <br>
        Yes! You can now choose your exact spot on the Pixel Wall — from both desktop and mobile devices. We’re continuously improving the user experience to make it even smoother on all platforms.
        </p>
      </li>
      <li>
        <p><span class="step">What is the minimum or maximum amount of pixels I can buy?</span>
        <br>
        The minimum area you can buy is 1x1 square (10x10 pixels). The only limitation is availability on the Pixel Wall. Grab a bigger spot while it lasts — once it's taken, it's gone!
        </p>
      </li>
      <li>
        <p><span class="step">Where can I see the price for 1 pixel?</span>
        <br>
        Once logged in with your Xaman Wallet, you can see the live price by clicking on any available (free) pixel square on the wall.
        </p>
      </li>
      <li>
        <p><span class="step">Can I change the size and form during the buying process?</span>
        <br>
        Yes. You can adjust sizes and forms until the order is submitted. Just close the checkout window and start again from step 1.
        </p>
      </li>
      <li>
        <p><span class="step">What picture should I choose to upload?</span>
        <br>
        Choose any image you like! We recommend pixel art-style or bold, high-contrast visuals for the best results.
        </p>
      </li>
      <li>
        <p><span class="step">Can I upload animated GIFs?</span>
        <br>
        Yes! You can now upload animated GIFs and bring your Pixel spot to life.
        </p>
      </li>
      <li>
        <p><span class="step">What kind of link can I submit?</span>
        <br>
        You can submit your website, X profile, Facebook, Twitch, LinkedIn, YouTube video, or any other link that follows our content guidelines.
        </p>
      </li>
      <li>
        <p><span class="step">What picture formats are accepted?</span>
        <br>
        JPG, PNG, and GIF.
        </p>
      </li>
      <li>
        <p><span class="step">Will I receive a payment confirmation after purchase?</span>
        <br>
        Yes. You'll receive an email with a unique order number after a successful checkout. Your transaction will also be visible in your Pixel Wall account and in your Xaman Wallet.
        </p>
      </li>
      <li>
        <p><span class="step">How long will it take to update the Pixel Wall after my purchase?</span>
        <br>
        Images are posted automatically and should appear right away. If not, give the page a refresh or clear your cookies.
        </p>
      </li>
      <li>
        <p><span class="step">Can I update (change) my image later?</span>
        <br>
        Yes! You can log in to your Pixel Wall account and change your image anytime for a small extra fee.
        </p>
      </li>
      <li>
        <p><span class="step">How big is one square on the wall?</span>
        <br>
        Each square is 100 pixels (10x10), also referred to as 1x1 squares.
        </p>
      </li>
      <li>
        <p><span class="step">Are there any restricted areas on the wall?</span>
        <br>
        You can’t select spots in the middle of the wall that are reserved for XRP leaders. Districts dedicated to specific projects (e.g., Money Minded Apes) require relevant images like NFTs, logos, or text. Other reserved or exclusive areas may also be restricted.
        </p>
      </li>
      <li>
        <p><span class="step">What’s the best way to contact the team for questions, partnerships, or other topics?</span>
        <br>
        The easiest and fastest way to reach us is by sending a direct message (DM) to our official X page: <a style="color: white;" href="https://x.com/Millionpixelxrp" target="_blank">@Millionpixelxrp</a>. We’re always happy to chat!
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FaqPage',
  data() {
    return {
      squarePrice: process.env.VUE_APP_SQUARE_PRICE
    }
  }
}
</script>

<style scoped>
</style>
